import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerSendingDomainQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "sending-domains",
  ],
};
